<template>
    <div class="modal" id="cart">
        <div class="modal-backdrop" @click="reloadPage()"></div>
        <div class="modal-block" @click.stop>
            <button class="modal-btn md" @click="reloadPage()">
                <img src="@/assets/img/close.webp" alt="close" />
            </button>
            <div class="modal-body">
                <div class="modal-body__container">
                    <buttons-toggle v-model="activeTab" nameInput="item" v-if="isPayment" @addressChange="this.$emit('addressChange')" />
                    <template v-if="activeTab == 2">
                        <template v-if="totalCountCart()">
                            <template v-if="isOrderProducts">
                                <h3 class="count-products">{{ totalCountCart() }} товара на сумму {{ totalPriceCart() }}{{ rub }}</h3>
                                <div class="products">
                                    <template v-for="product in cartItems" :key="product.id">
                                        <div class="product" v-if="product.quantity">
                                            <div class="product__img">
                                                <img :src="product.image ? product.image : require(`@/assets/img/no-photo.jpg`)" alt="image" />
                                            </div>
                                            <div class="product__body">
                                                <div class="product__head">
                                                    <h4 class="product__title">{{ product.name }}</h4>
                                                    <div class="product__weight">{{ Math.floor(Number(product.weight)) }} г</div>
                                                    <span v-if="product.mods" class="product__weight mod">
                                                    <p
                                                        v-for="group in product.mods"
                                                        :key="group.id"
                                                    >
                                                        <span v-for="mod in group.items" :key="mod.id">{{ mod.name }}</span>
                                                    </p>
                                                </span>
                                                </div>
                                                <div class="product__bottom">
                                                    <div class="product__price">
                                                        {{ (product.final_price ? product.final_price : product.price) * product.quantity }}
                                                        {{ rub }}
                                                    </div>
                                                    <div class="counter">
                                                        <span class="minus" @click="$emit('minusToCart', product)">-</span>
                                                        <span class="count">{{ product.quantity }}</span>
                                                        <span class="plus" @click="$emit('plusToCart', product)">+</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="strokes">
                                    <div class="stroke">
                                        <span><img :src="require(`@/assets/img/svg/devices.svg`)" alt="img" /> Количество приборов</span>
                                        <div class="counter">
                                            <span class="minus" @click="countDevDecr">-</span>
                                            <span class="count">{{ countDev }}</span>
                                            <span class="plus" @click="countDevIncr">+</span>
                                        </div>
                                    </div>
                                    <!--@click="isInputPromocode = true"-->
                                    <div class="stroke" @click="isInputPromocode = true">
                                        <div class="inputPromocode block-flex" v-if="isInputPromocode || promo_code">
                                            <div class="block-input">
                                                <span v-if="isCheckPromocode || promo_code" :class="promocode.active && promocode.type !== 'Product' ? 'promocode' : 'error'">{{ inputPromocode }}</span>
                                                <input v-else type="text" name="promocode" placeholder="Введите промокод" v-model="inputPromocode" @input="inputValidPromocode" :maxlength="maxLength" :disabled="isCheckPromocode ? true : false" />
                                                <div class="check_promocode" :class="check_promocode !== '' ? 'error' : ''">
                                                    {{ check_promocode }}
                                                </div>
                                                <div v-if="promocode.active && promocode.type !== 'Product'" class="discount">
                                                    <!-- Скидка 50% при заказе от 599р -->
                                                    <div class="promocode_active">
                                                        <span>Скидка по промокоду</span>
                                                        <span v-if="promocode.type === 'FlexibleSum'"> {{ promocode.amount }} % </span>
                                                        <span v-else-if="promocode.type === 'Percent'"> {{ promocode.amount }} % </span>
                                                        <span v-else> {{ amount }} {{ rub }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <button v-if="!isCheckPromocode && !promo_code" @click="applyPromocode(inputPromocode)" class="btn btn-apply">Применить</button>
                                            <button v-else @click="removePromoCode" class="btn btn-remove">Удалить</button>
                                        </div>
                                        <template v-else>
                                            <div class="block-flex">
                                                <span>Ввести промокод</span>
                                                <button class="btn-back">
                                                    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8.52639 1.4209L1.78955 8.99985L8.52639 16.5788" stroke="#C8C8C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </template>
                                    </div>
                                    <template v-if="token && can_use_bonuses">
                                        <div class="stroke" @click="isInputTicoins = true" v-if="isWriteTicoins">
                                            <div class="block-flex" v-if="isInputTicoins && !isWriteCount">
                                                <div class="block-input">
                                                    <input type="text" placeholder="Введите кол-во" min="1" v-model="write" @keyup="inputWrite" maxlength="5" name="write" />
                                                </div>
                                                <button class="btn btn-apply" @click="writeTicoins()">Списать</button>
                                            </div>
                                            <div v-else @click="(isInputTicoins = false), (isWriteCount = false), (write = null)" class="btn-write">Списать Т-коины</div>
                                        </div>
                                        <div class="stroke" v-else>
                                            <div class="btn-write" @click="(isWriteTicoins = true), (isInputTicoins = false), (isWriteCount = false), (write = null)">Отменить списание</div>
                                        </div>
                                        <div class="write-ticoins" v-if="isInputTicoins">
                                            <div class="bonuses">
                                                На вашем счету <span>{{ bonuses }}</span>
                                                <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M5.49926 4.79101C4.51881 4.79101 3.72449 5.59478 3.72449 6.58519C3.76171 7.71182 4.35355 8.84974 5.49926 9.9997C4.80171 10.008 4.2255 9.84316 3.55698 9.61663C1.45019 8.90317 0 6.79366 0 4.41396V0.706685C1.65417 0.706685 2.9443 1.66173 2.9443 3.96466C2.9443 1.71817 3.93889 0.938483 5.5 0C7.06037 0.937731 8.0557 1.71817 8.0557 3.96466C8.0557 1.66173 9.34583 0.706685 11 0.706685V4.41396C11 6.7929 9.54981 8.90317 7.44302 9.61663C6.7745 9.84316 6.19829 10.008 5.50074 9.9997C6.64645 8.84974 7.23829 7.71182 7.27551 6.58519C7.27551 5.59402 6.48119 4.79101 5.50074 4.79101"
                                                        fill="#3B7351"
                                                    />
                                                </svg>
                                            </div>
                                            <div class="write" v-if="isWriteCount && !error_write">
                                                Будет списано
                                                <span> - {{ write }}</span>
                                                <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M5.49926 4.79101C4.51881 4.79101 3.72449 5.59478 3.72449 6.58519C3.76171 7.71182 4.35355 8.84974 5.49926 9.9997C4.80171 10.008 4.2255 9.84316 3.55698 9.61663C1.45019 8.90317 0 6.79366 0 4.41396V0.706685C1.65417 0.706685 2.9443 1.66173 2.9443 3.96466C2.9443 1.71817 3.93889 0.938483 5.5 0C7.06037 0.937731 8.0557 1.71817 8.0557 3.96466C8.0557 1.66173 9.34583 0.706685 11 0.706685V4.41396C11 6.7929 9.54981 8.90317 7.44302 9.61663C6.7745 9.84316 6.19829 10.008 5.50074 9.9997C6.64645 8.84974 7.23829 7.71182 7.27551 6.58519C7.27551 5.59402 6.48119 4.79101 5.50074 4.79101"
                                                        fill="#d66c56"
                                                    />
                                                </svg>
                                            </div>
                                            <div class="error" v-if="error_write">{{ error_write }}</div>
                                        </div>
                                    </template>
                                </div>
                                <div class="total-price">
                                    <div class="total-price__shipping" v-if="activeTab === 1">
                                        <span>Доставка</span>
                                        <span>{{ totalSumDelivery() }} {{ rub }}</span>
                                    </div>
                                    <div class="total-price__total">
                                        <span>Итого</span>
                                        <div v-if="promocode.active && promocode.type !== 'Product'">
                                            <span v-if="promocode.type === 'FlexibleSum'">
                                                {{ activeTab === 1 ? Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) + totalSumDelivery() - write) : Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) - write) }}
                                                {{ rub }}
                                            </span>
                                            <span v-else-if="promocode.active && promocode.type === 'Percent'">
                                                {{ activeTab === 1 ? Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) + totalSumDelivery() - write) : Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) - write) }}
                                                {{ rub }}
                                            </span>
                                        </div>
                                        <div v-else>
                                            {{ activeTab === 1 ? Math.round(totalPriceCart() + totalSumDelivery() - write) : Math.round(totalPriceCart() - write) }}
                                            {{ rub }}
                                        </div>
                                    </div>
                                    <span class="error" v-if="error">
                                        {{ error }}
                                    </span>
                                    <btn-name :btnName="activeTab === 1 ? (totalPriceCart() > minSum ? 'Оформить заказ' : textDisabled) : 'Оформить заказ'" btnClass="btnCart" :disabled="activeTab === 1 ? (totalPriceCart() > minSum ? false : true) : false" @click="nextStep()" />
                                </div>
                            </template>
                            <template v-else>
                                <div class="block-payment" v-if="isPayment">
                                    <div class="body">
                                        <h4 class="head-title">Время готовности</h4>
                                        <input type="hidden" v-model="shipping_type" />
                                        <div class="time-shipping">
                                            <button class="time-shipping__btn" v-for="shipping in shippings" :key="shipping.id" :class="shipping_type === shipping.value ? 'active' : ''" @click="shipping_type = shipping.value">
                                                {{ shipping.name }}
                                            </button>
                                        </div>
                                        <input type="hidden" v-model="time_interval" />
                                        <div class="time-interval" v-if="shipping_type === 'later'">
                                            <div class="time-interval__time" :class="time_interval === interval ? 'active' : ''" @click="time_interval = interval" v-for="(interval, index) in intervals" :key="index">
                                                {{ interval }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="body" v-if="activeTab === 2">
                                        <h4 class="head-title">Способ получения</h4>
                                        <input type="hidden" v-model="delivery_type" />
                                        <div class="methods">
                                            <div class="methods__block" :class="delivery_type === label.value ? 'active' : ''" v-for="label in labels" :key="label.id" @click="delivery_type = label.value">
                                                <div class="methods__img">
                                                    <img :src="require(`@/assets/img/3d/${label.img}`)" alt="img" />
                                                </div>
                                                <h4 class="methods__title" :value="label.value">{{ label.name }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="body" v-if="!token">
                                        <h4 class="head-title">Оплата</h4>
                                        <!-- <pays /> -->
                                        <div class="block-input">
                                            <MaskInput v-model="vmPhone" mask="+7 ### ### ## ##" placeholder="Введите номер телефона" @input="inputPhone" :value="'+7 ' + valuePhone" />
                                        </div>
                                    </div>
                                    <span class="error" v-if="error">
                                        {{ error }}
                                    </span>
                                    <div class="body">
                                        <h4 class="head-title">Комментарий к заказу</h4>
                                        <textarea name="comment-order" id="comment-order" placeholder="Например, не добавлять соус в кыстыбургер" v-model="comment"></textarea>
                                    </div>
                                    <div class="total-price">
                                        <div class="total-price__shipping">
                                            <span>{{ totalCountCart() }} товара на сумму</span>
                                            <span>{{ totalPriceCart() }} {{ rub }}</span>
                                        </div>
                                        <div class="total-price__total">
                                            <span>К оплате</span>
                                            <div v-if="promocode.active && promocode.type !== 'Product'">
                                                <span v-if="promocode.type === 'FlexibleSum'">
                                                    {{ activeTab === 1 ? Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) + totalSumDelivery() - write) : Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) - write) }}
                                                    {{ rub }}
                                                </span>
                                                <span v-else-if="promocode.active && promocode.type === 'Percent'">
                                                    {{ activeTab === 1 ? Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) + totalSumDelivery() - write) : Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) - write) }}
                                                    {{ rub }}
                                                </span>
                                            </div>
                                            <div v-else>
                                                {{ activeTab === 1 ? Math.round(totalPriceCart() + totalSumDelivery() - write) : Math.round(totalPriceCart() - write) }}
                                                {{ rub }}
                                            </div>
                                        </div>
                                        <btn-name :btnName="activeTab === 1 ? (totalPriceCart() > minSum ? 'Оформить заказ' : textDisabled) : 'Оформить заказ'" btnClass="btnCart" :disabled="activeTab === 1 ? (totalPriceCart() > minSum ? false : true) : false" @click="sendPayment()" />
                                    </div>
                                </div>
                                <div class="status-order" v-else>
                                    <template v-if="isNumberGuest">
                                        <div class="number-order">{{ nameGuest }} ({{ guest_number }})</div>
                                        <h4 class="status-title">Статус заказа</h4>
                                        <steps-order :orderStatus="orderStatus" />
                                    </template>
                                    <h4 class="status-title">Детали заказа</h4>
                                    <div class="products">
                                        <template v-for="item in cartItems" :key="item.id">
                                            <div class="product" v-if="item.quantity">
                                                <div class="product__img">
                                                    <img :src="item.image ? item.image : require(`@/assets/img/no-photo.jpg`)" alt="image" />
                                                </div>
                                                <div class="product__body">
                                                    <div class="product__head">
                                                        <h4 class="product__title">{{ item.name }}</h4>
                                                        <div class="product__weight">{{ Math.floor(Number(item.weight)) }} г</div>
                                                        <span v-if="item.mod_id" class="product__weight">
                                                            {{ item.modifiers.find((x) => x.id == item.mod_id).name }}
                                                        </span>
                                                    </div>
                                                    <div class="product__bottom">
                                                        <div class="product__price">
                                                            {{ (product.final_price ? product.final_price : product.price) * product.quantity }}
                                                            {{ rub }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="address">
                                        <div class="address__title">Адрес {{ activeTab === 2 ? "самовывоза" : "доставки" }}</div>
                                        <div class="address__street">
                                            <template v-if="activeTab == 1">
                                                <span>{{ getDeliveryData?.address.address }}, кв.{{ getDeliveryData?.address.flat }}</span>
                                            </template>
                                            <template v-else>
                                                <span>{{ getPickupData?.address }}</span>
                                                <span>{{ delivery_type === "packed_pickup" ? "С собой" : "В зале" }}</span>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="time-order">
                                        <div class="time-order__order">
                                            <span>Время заказа</span>
                                            <span>{{ nowDate }} в {{ this.now.toLocaleTimeString().slice(0, -3) }}</span>
                                        </div>
                                        <div class="time-order__done">
                                            <span>Время выдачи</span>
                                            <span>{{ nowDate }} в {{ shipping_type === "later" ? time_interval.split("-")[1] : fastDeliveryTime }}</span>
                                        </div>
                                    </div>
                                    <div class="total-price">
                                        <div class="total-price__shipping">
                                            <span>{{ totalCountCart() }} товара на сумму</span>
                                            <span>{{ totalPriceCart() }} {{ rub }}</span>
                                        </div>
                                        <div class="total-price__t-coins write" v-if="write">
                                            <span>Списано Т-коинов</span>
                                            <span>-{{ write }}</span>
                                        </div>
                                        <div class="total-price__t-coins">
                                            <span>Начислим Т-коинов</span>
                                            <span>+{{ Math.floor(totalPriceCart() / 20) }}</span>
                                        </div>
                                        <div class="total-price__discounts" v-if="promocode.active && promocode.type !== 'Product'">
                                            <span>Скидка по промокоду</span>
                                            <span v-if="promocode.type === 'FlexibleSum'"> {{ promocode.amount }} % </span>
                                            <span v-else-if="promocode.type === 'Percent'"> {{ promocode.amount }} % </span>
                                            <span v-else> {{ amount }} {{ rub }}</span>
                                        </div>
                                        <div class="total-price__total">
                                            <span>Итого</span>
                                            <div v-if="promocode.active && promocode.type !== 'Product'">
                                                <span v-if="promocode.type === 'FlexibleSum'">
                                                    {{ activeTab === 1 ? Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) + totalSumDelivery() - write) : Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) - write) }}
                                                    {{ rub }}
                                                </span>
                                                <span v-else-if="promocode.active && promocode.type === 'Percent'">
                                                    {{ activeTab === 1 ? Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) + totalSumDelivery() - write) : Math.round(totalPriceCart() - (totalPriceCart() / 100) * Number(promocode.amount) - write) }}
                                                    {{ rub }}
                                                </span>
                                            </div>
                                            <div v-else>
                                                {{ activeTab === 1 ? Math.round(totalPriceCart() + totalSumDelivery() - write) : Math.round(totalPriceCart() - write) }}
                                                {{ rub }}
                                            </div>
                                        </div>
                                        <button class="btn-bn btnCart" @click="isReview = true">Оставить отзыв</button>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="modal-body__empty">
                                <div class="modal-body__cart-img md">
                                    <img src="@/assets/img/3d/cart_empty.png" alt="cart" />
                                </div>
                                <div class="modal-body__cart-img mm">
                                    <img src="@/assets/img/3d/cart.png" alt="cart" />
                                </div>
                                <div class="modal-body__message">
                                    <p>В корзине пока</p>
                                    <p>ничего нет</p>
                                </div>
                            </div>
                            <button class="modal-body__btn" disabled>{{ textDisabled }}</button>
                        </template>
                    </template>
                    <template v-else>
                        <delivery-yandex-food />
                        <btn-yandex-food />
                    </template>
                </div>
            </div>
        </div>
    </div>
    <alert v-if="isAlert && isOrderProducts" title="Способ заказа" :message="`При изменении самовывоза может измениться\n наличие товара`" @close="isAlert = false" @showModal="this.$emit('showModal')" />
    <review v-if="isReview" @close="isReview = false" />
    <login-modal v-if="isLoginModal" @click="isLoginModal = false" @close="isLoginModal = false" :display="2" />
</template>

<script>
import apiClient, { PROJECT_PREFIX } from "@/api";
import { withRequiredMods } from "@/utils/productMods";
import axios from "axios";
import StepsOrder from "../StepsOrder.vue";
import BtnName from "../UI/BtnName.vue";
import ButtonsToggle from "../UI/ButtonsToggle.vue";
import Alert from "@/components/popups/Alert.vue";
import Review from "../popups/Review.vue";
import LoginModal from "./LoginModal.vue";
//import Pays from "../UI/Pays.vue";
import DeliveryYandexFood from "@/components/DeliveryYandexFood.vue";
import BtnYandexFood from "@/components/BtnYandexFood.vue";
export default {
    components: { ButtonsToggle, BtnName, StepsOrder, Alert, Review, LoginModal, DeliveryYandexFood, BtnYandexFood /*Pays*/ },
    props: ["product"],
    emits: ["minusToCart", "plusToCart", "addressChange", "showModal", "close", "cart-updated"],
    data() {
        return {
            write: null,
            error_write: null,
            isWriteTicoins: true,
            isInputTicoins: false,
            isWriteCount: false,
            orderObj: {},
            isLoginModal: false,
            status: "",
            orderStatus: "",
            number_order: 0,
            guest_number: 0,
            sumDelivery: 99,
            vmPhone: "",
            minSum: 799,
            textDef: `Добавьте товары`,
            rub: "₽",
            isAlert: false,
            isReview: false,
            items: [],
            totalPrice: 0,
            isInputPromocode: false,
            inputPromocode: JSON.parse(localStorage.getItem("promocode"))?.code ?? "",
            maxLength: 10,
            amount: "",
            promocode: {
                active: false,
                code: "",
                amount: null,
                description: null,
                validation: true,
                error: null,
                type: null,
            },
            isOrderProducts: true,
            isPayment: true,
            delivery_type: "pickup_on_tray",
            shipping_type: "fast",
            time_interval: "",
            chopsticks: 0,
            now: new Date(),
            now2: new Date(),
            token: localStorage.getItem("token"),
            labels: [
                { id: 1, name: "В зале", img: "with_him.png", value: "pickup_on_tray" },
                { id: 2, name: "С собой", img: "in_hall.png", value: "packed_pickup" },
            ],
            orderId: localStorage.getItem("orderId") ?? null,
            shop_id: 2,
            countDev: 1,
            activeTab: Number(localStorage.getItem("tabToggle")),
            shippings: [
                { id: 1, name: "Как можно скорее", value: "fast" },
                { id: 2, name: "Готовить позже", value: "later" },
            ],
            intervals: [],
            error: null,
            getDeliveryData: JSON.parse(localStorage.getItem("delivery_data")),
            getPickupData: JSON.parse(localStorage.getItem("pickup_data")),
            fastDeliveryTime: "",
            valuePhone: localStorage.getItem("phone") ?? "",
            order_type: localStorage.getItem("order_type"),
            bonuses: 0,
            percent: 0,
            isCheckPromocode: false,
            check_promocode: "",
            longitude: localStorage.getItem("longitude"),
            latitude: localStorage.getItem("latitude"),
            comment: window.location.href.indexOf("localhost") != -1 ? "это тестирование (игнорировать!)" : "",
            promo_code: JSON.parse(localStorage.getItem("promocode")) ?? null,
            shops: null,
            can_use_bonuses: false,
            nameGuest: localStorage.getItem("name") ?? "Гость",
            isNumberGuest: false,
        };
    },

    methods: {
        inputWrite(v) {
            this.write = v.target.value.replace(/[^0-9]/g, "");
        },
        writeTicoins() {
            let sum = this.activeTab === 1 ? this.totalPriceCart() + this.totalSumDelivery() : this.totalPriceCart();
            if (!this.write) {
                this.error_write = "Введите кол-во Т-коинов";
            } else if (Number(this.write) === sum) {
                this.error_write = "Кол-во Т-коинов не должно быть равно сумме заказа";
            } else if (Number(this.write) > sum) {
                this.error_write = "Кол-во Т-коинов не должно быть больше суммы заказа";
            } else if (Number(this.write) > this.bonuses) {
                this.error_write = "Не хватает Т-коинов";
            } else {
                this.error_write = null;
                this.isWriteCount = true;
                this.isWriteTicoins = false;
            }
        },
        reloadPage() {
            if (this.$router.path !== window.location.href) {
                window.location = window.location.href.split("/?")[0];
            } else {
                window.location.reload();
            }
        },
        fetchShops() {
            apiClient
                .get(PROJECT_PREFIX + "/shops/")
                .then((response) => {
                    this.shops = response.data;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        fetchProducts() {
            if (this.getPickupData && this.shops) {
                const shop = this.order_type == "by_pickup" ? this.getPickupData : this.shops.find((x) => x.id == this.getDeliveryData.shop);

                apiClient
                    .get(PROJECT_PREFIX + `/shops/${shop.code}/products/?available=${this.order_type}/`)
                    .then((response) => {
                        console.log(response);
                        if (response.status == 200) {
                            this.products = response.data.results;
                        }
                    })
                    .catch((e) => {
                        this.errors = e.message;
                    });
            }
        },

        inputPhone() {
            this.vmPhone && this.vmPhone.length >= 13 ? (this.error = "") : (this.error = "Введите телефон");
        },
        tabShow(tab) {
            this.$emit("showModal");
            this.$emit("addressChange");
            if (tab == 2) {
                if (this.getPickupData) {
                    this.isAlert = true;
                }
            }
        },
        countDevDecr() {
            this.countDev > 1 ? this.countDev-- : (this.countDev = 1);
        },
        countDevIncr() {
            this.countDev++;
        },
        hrefOpen() {
            window.innerWidth <= 768 ? window.open("https://apps.apple.com/ru/app/%D1%82%D1%8E%D0%B1%D0%B5%D1%82%D0%B5%D0%B9/id1594385089", "_self") : window.open("/discounts", "_blank");
        },
        sendPayment() {
            if ((this.vmPhone && this.vmPhone.length < 13) || (this.valuePhone && this.valuePhone.length < 13)) {
                this.error = "Введите телефон";
            } else if (this.activeTab === 1 && !this.getDeliveryData) {
                this.error = "Укажите адрес доставки";
            } else if (this.activeTab === 2 && !this.getPickupData) {
                this.error = "Выберите точку самовывоза";
            } else {
                this.sendOrder();
            }
        },
        async refreshCartProductMetadata() {
            const orderItems = this.items.filter((item) => item.type !== "discounted" && !item.fast_set && !item.custom_fast_set);
            if (!orderItems.length) return null;

            try {
                let shops = this.shops;
                if (!Array.isArray(shops)) {
                    const shopsResponse = await apiClient.get(PROJECT_PREFIX + "/shops/");
                    shops = shopsResponse.data;
                    this.shops = shops;
                }

                const shop = this.order_type === "by_pickup"
                    ? this.getPickupData
                    : shops.find((value) => String(value.id) === String(this.getDeliveryData?.shop));
                if (!shop?.code) return "Не удалось определить ресторан. Проверьте способ заказа и обновите страницу.";

                const response = await apiClient.get(
                    PROJECT_PREFIX + `/shops/${shop.code}/products/?available=${this.order_type}/`
                );
                const catalog = Array.isArray(response.data?.results) ? response.data.results : [];
                const refreshed = [];

                for (const item of this.items) {
                    if (item.type === "discounted" || item.fast_set || item.custom_fast_set) {
                        refreshed.push(item);
                        continue;
                    }

                    const current = catalog.find((product) => String(product.id) === String(item.id));
                    if (!current) {
                        return `«${item.name || item.real_name || "Товар"}» больше не найдено в меню. Удалите его из корзины и добавьте заново.`;
                    }
                    if (!Array.isArray(current.group_mods)) {
                        return `Не удалось проверить обязательные модификаторы у товара «${item.name || item.real_name || "Товар"}». Обновите меню и попробуйте снова.`;
                    }

                    const normalized = withRequiredMods({
                        ...current,
                        ...item,
                        group_mods: current.group_mods,
                        mods: Array.isArray(item.mods) ? item.mods : (Array.isArray(current.mods) ? current.mods : []),
                    });
                    if (!normalized) {
                        return `Не удалось восстановить обязательный модификатор у товара «${item.name || item.real_name || "Товар"}». Удалите его из корзины и добавьте заново.`;
                    }
                    refreshed.push(normalized);
                }

                this.items = refreshed;
                localStorage.setItem("cart", JSON.stringify(refreshed));
                return null;
            } catch (error) {
                console.error("Не удалось обновить модификаторы корзины:", error);
                return "Не удалось проверить меню и обязательные модификаторы. Проверьте интернет и попробуйте снова.";
            }
        },
        buildOrderItems() {
            const items = [];
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].type === "discounted") continue;
                const product = withRequiredMods(this.items[i]);
                if (!product) return null;
                if (!product.fast_set && !product.custom_fast_set && !Array.isArray(product.group_mods)) return null;

                if (!product.fast_set && !product.custom_fast_set) {
                    for (const group of product.group_mods) {
                        const minQty = Number(group?.restrictions?.minQuantity) || 0;
                        if (minQty < 1) continue;
                        const selection = (Array.isArray(product.mods) ? product.mods : []).find(
                            (value) => String(value.id) === String(group.id)
                        );
                        const selectedCount = (Array.isArray(selection?.items) ? selection.items : []).filter(
                            (selected) => group.items?.some((option) => String(option.id) === String(selected.id))
                        ).length;
                        if (selectedCount < minQty) return null;
                    }
                }

                const mods = Array.isArray(product.mods)
                    ? product.mods.map((g) => ({
                          id: g.id,
                          items: Array.isArray(g.items)
                              ? g.items.map((it) => ({ id: it.id, name: it.name }))
                              : [],
                      }))
                    : [];
                const condiments = Array.isArray(product.active_condiments)
                    ? product.active_condiments.map((c) => ({ id: c.id }))
                    : [];
                items.push({
                    id: product.id,
                    quantity: product.quantity ?? product.count ?? 1,
                    mods,
                    condiments,
                });
            }
            return items;
        },

        validateCart() {
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].type === "discounted") continue;
                const product = withRequiredMods(this.items[i]);
                if (!product) {
                    return `«${this.items[i].name || this.items[i].real_name || "Товар"}»: обязательный модификатор недоступен`;
                }
                if (product.fast_set || product.custom_fast_set) continue;
                if (!Array.isArray(product.group_mods)) {
                    return `«${product.name || product.real_name || "Товар"}»: не удалось проверить обязательные модификаторы. Обновите меню и попробуйте снова`;
                }
                const groups = Array.isArray(product.group_mods) ? product.group_mods : [];
                for (const group of groups) {
                    const minQty = Number(group?.restrictions?.minQuantity) || 0;
                    if (minQty >= 1) {
                        const selection = (Array.isArray(product.mods) ? product.mods : []).find(
                            (g) => String(g.id) === String(group.id)
                        );
                        const selectedCount =
                            selection && Array.isArray(selection.items)
                                ? selection.items.filter((selected) => group.items?.some((option) => String(option.id) === String(selected.id))).length
                                : 0;
                        if (selectedCount < minQty) {
                            return `«${product.name || product.real_name || "Товар"}»: выберите обязательный модификатор «${group.name}»`;
                        }
                    }
                }
            }
            return null;
        },

        async sendOrder() {
            if (!this.isPayment) return;
            this.error = null;
            const metadataError = await this.refreshCartProductMetadata();
            if (metadataError) {
                this.error = metadataError;
                return;
            }

            const validationError = this.validateCart();
            if (validationError) {
                this.error = validationError;
                return;
            }
            const items = this.buildOrderItems();
            if (!items) {
                this.error = "Не удалось проверить обязательные модификаторы. Обновите меню и попробуйте снова.";
                return;
            }
            let discount_code = this.promocode.code ?? null;

            if (items.length !== 0) {
                this.isPayment = false;
                apiClient
                    .post(
                        PROJECT_PREFIX + `/orders/`,
                        {
                            shop_id: this.order_type !== "by_pickup" ? this.getDeliveryData.shop : this.getPickupData.id,
                            items: items,
                            bonuses: this.write ? Number(this.write) : false,
                            delivery_type: this.order_type == "by_delivery" ? "DeliveryByCourier" : this.delivery_type,
                            express: true,
                            discount_code: discount_code,
                            order_date: this.now.toLocaleDateString(),
                            order_time_from: this.now.toLocaleTimeString().slice(0, -3),
                            order_time_to: this.shipping_type === "later" ? this.time_interval.split("-")[1] : this.fastDeliveryTime,
                            app_version: "Сайт",
                            longitude: this.order_type !== "by_pickup" ? this.longitude : this.getPickupData.longitude,
                            latitude: this.order_type !== "by_pickup" ? this.latitude : this.getPickupData.latitude,
                            street: this.order_type !== "by_pickup" ? this.getDeliveryData.address.address : "",
                            house: this.order_type !== "by_pickup" ? this.getDeliveryData.address.address.split(",")[1].trim() : "",
                            flat: this.order_type !== "by_pickup" ? this.getDeliveryData.address.flat : "",
                            comment: this.comment,
                        },
                    )
                    .then((response) => {
                        console.log(response);
                        if (response.data.success) {
                            localStorage.setItem("orderId", response.data.order.id);
                            if (window.location.href.indexOf("localhost") == -1) {
                                setTimeout(() => {
                                    window.open(response.data.redirect_url, window.innerWidth <= 768 ? "_parent" : "_self");
                                }, 2000);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        inputValidPromocode() {
            this.inputPromocode = this.inputPromocode.toUpperCase();
        },

        applyPromocode(inputPromocode) {
            if (!inputPromocode) {
                this.check_promocode = "Введите промокод";
            } else {
                this.promocode.code = inputPromocode;
                this.checkDiscount();
                this.isCheckPromocode = true;
            }
        },

        checkDiscount() {
            //проверки скидки/промокода перед совершением заказа
            if ((this.items, this.promocode.code)) {
                let data = {
                    discount_code: this.promocode.code,
                    items: [],
                };

                // for (let i = 0; i < this.items.length; i++) {
                //     if (this.items[i].type !== "discounted") {
                //         let item = {
                //             id: this.items[i].id,
                //             quantity: this.items[i].count,
                //         };

                //         data.items.push(item);
                //     }
                // }
                data.items = this.buildOrderItems();
                if (!data.items) {
                    this.check_promocode = "Сначала обновите корзину и проверьте обязательные модификаторы";
                    return;
                }

                if (this.getPickupData && this.shops) {
                    const shop = this.order_type == "by_pickup" ? this.getPickupData : this.shops.find((x) => x.id == this.getDeliveryData.shop);
                    apiClient
                        .post(
                            PROJECT_PREFIX + `/shops/${shop.code}/check-discount/`,
                            {
                                discount_code: data.discount_code,
                                items: data.items,
                            },
                        )
                        .then((response) => {
                            console.log(response);
                            if (response.status == 200) {
                                this.promocode.active = true;
                                this.applyDiscount(response.data);
                                this.check_promocode = "";
                            }
                        })
                        .catch((error) => {
                            this.promocode.validation = false;
                            this.promocode.error = error.response?.data.error;
                            this.check_promocode = this.promocode.error;
                        });
                }
            }
        },

        applyDiscount(data) {
            this.promocode.description = data.description;
            this.promocode.type = data.type;
            this.promocode.amount = data.amount;
            if (data.type === "Product") {
                const elem = this.items.find((item) => item.id === data.product.id);
                if (!elem) {
                    data.product.name = data.product.real_name;
                    data.product.type = "discounted";
                    data.product.this.items.push(data.product);
                    localStorage.setItem("cart", JSON.stringify(this.items));
                    this.totalPriceCart();
                }
            }
            localStorage.setItem("promocode", JSON.stringify(this.promocode));
        },

        checkPromocode() {
            let promocode = JSON.parse(localStorage.getItem("promocode")) ?? null;
            if (promocode) {
                this.promocode = promocode;
            }
        },

        removePromoCode() {
            this.isCheckPromocode = false;
            this.inputPromocode = "";
            this.check_promocode = "";
            this.promocode.validation = false;
            this.promocode.active = false;
            this.promo_code = null;
            localStorage.removeItem("promocode");
        },

        totalCountCart() {
            const array = JSON.parse(localStorage.getItem("cart")) ?? [];
            let items = [];
            if (array) {
                for (let i = 0; i < array.length; i++) {
                    if (array[i].type !== "discounted") {
                        items.push(array[i]);
                    }
                }
            }
            return items.reduce((acc, item) => acc + Number(item.quantity ?? item.count ?? 0), 0);
        },

        nextStep() {
            if (this.token) {
                this.isLoginModal = false;
                this.vmPhone = this.valuePhone;
                this.isOrderProducts = false;
            } else {
                this.isLoginModal = true;
            }
        },
        totalPriceCart() {
            const array = JSON.parse(localStorage.getItem("cart")) ?? [];
            let items = [];
            if (array) {
                for (let i = 0; i < array.length; i++) {
                    if (array[i].type !== "discounted") {
                        items.push(array[i]);
                    }
                }
            }
            return items.reduce((acc, item) => {                
                return acc + (item.final_price ? item.final_price : item.price) * Number(item.quantity ?? item.count ?? 0);
            }, 0);
        },
        totalSumDelivery() {
            return this.totalPriceCart() >= 1300 ? (this.sumDelivery = 0) : (this.sumDelivery = 99);
        },
        updateItems() {
            this.items = JSON.parse(localStorage.getItem("cart")) ?? [];
        },
        checkOrderStatus() {
            let webSocket = new WebSocket(`${process.env.VUE_APP_WS_BASE_URL}/orders/${this.orderId}/`);
            webSocket.onopen = () => {
                console.log("WebSocket открыт");
            };
            webSocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                localStorage.removeItem("cart");
                if (data.order.event == "status_update") {
                    this.orderStatus = data.order.status_code;
                    console.log("Статус заказа: " + this.orderStatus);
                    if (data.order.status_code === "FINISHED") {
                        setTimeout(() => {
                            if (webSocket) {
                                webSocket.close();
                                webSocket = null;
                            }
                        }, 10000);
                    }
                }
                if (data.order.paid_error) {
                    this.paymentError = true;
                }
            };

            webSocket.onclose = () => {
                console.log("WebSocket закрыт");
            };

            webSocket.onerror = (error) => {
                console.error("WebSocket ошибка:", error);
            };
        },
    },
    computed: {
        nowDate() {
            const day = String(this.now.getDate()).padStart(2, "0");
            const month = String(this.now.getMonth() + 1).padStart(2, "0");
            const year = this.now.getFullYear();
            return `${day}.${month}.${year}`;
        },
        cartItems() {
            return this.items.map((item) => item);
        },
        textDisabled() {
            return this.textDef;
        },
    },
    watch: {
        getPickupData(newValue) {
            if (newValue) {
                this.fetchProducts();
            }
        },

        getDeliveryData(newValue) {
            if (newValue) {
                this.fetchProducts();
            }
        },
        $route: {
            handler: function (search) {
                console.log(search);
                console.log(search.fullPath);
                if (search.fullPath === `/menu/?success=true`) {
                    this.checkOrderStatus();
                    this.isOrderProducts = false;
                    this.isPayment = false;
                    this.isNumberGuest = true;
                    if (this.orderStatus == "FINISHED") {
                        setTimeout(() => {
                            localStorage.removeItem("cart");
                            this.orderStatus = "";
                            window.location.replace("/menu");
                        }, 5000);
                    }
                }
                if (search.fullPath === `/menu/?success=false`) {
                    this.isOrderProducts = false;
                    this.orderStatus = "";
                }
            },
            deep: true,
            immediate: true,
        },
        $props: {
            handler() {
                this.updateItems();
            },
            deep: true,
        },
    },
    mounted() {
        console.log("cart");
        for (let i = 0; i < this.items.length; i++) {
            console.log(this.items[i].id);
        }

        this.fetchShops();
        this.fetchProducts();
        this.checkPromocode();
        let hour = Number(this.now.toLocaleTimeString().split(":")[0]);
        let minut = Number(this.now.toLocaleTimeString().split(":")[1]);
        if (hour >= 10 && hour <= 22) {
            for (let i = 0; i < 3; i++) {
                this.intervals.push(String(hour + i).padStart(2, "0") + ":" + String(minut).padStart(2, "0") + " - " + String(hour + i + 1).padStart(2, "0") + ":" + String(minut).padStart(2, "0"));
            }
        } else {
            this.intervals.push("10:00 - 11:00", "11:00 - 12:00", "12:00 - 13:00");
        }
        this.time_interval = this.intervals[0];

        this.now.setTime(this.now.getTime() + 0 * 60 * 1000);
        this.now2.setTime(this.now.getTime() + 10 * 60 * 1000);
        this.fastDeliveryTime = String(this.now2.getHours()).padStart(2, "0") + ":" + String(this.now2.getMinutes()).padStart(2, "0");

        if (localStorage.getItem("cart")) {
            this.items = JSON.parse(localStorage.getItem("cart"));
        }
        if (this.orderId) {
            //отслеживание статуса заказа
            apiClient.get(PROJECT_PREFIX + "/orders/" + this.orderId).then((response) => {
                this.orderObj = response.data;
                this.status = response.data.status;
                this.number_order = response.data.order_number;
                this.guest_number = response.data.guest_number;
                // this.orderStatus = response.data.order_status.code;
                // console.log("Статус заказа: " + this.orderStatus);
                axios
                    .get("http://127.0.0.1:5000/payment/create/?amount=" + this.orderObj.full_price * 100)
                    .then((response) => {
                        this.onProccess = false;
                        console.log("TERMINAL: " + response.data);
                        if (response.data.success) {
                            console.log("TERMINAL: SUCCESS = " + response.data.success);
                            this.paymentError = false;
                            if (this.getPickupData && this.shops) {
                                const shop = this.order_type == "by_pickup" ? this.getPickupData : this.shops.find((x) => x.id == this.getDeliveryData.shop);
                                apiClient
                                    .post(PROJECT_PREFIX + `/shops/${shop.code}/order-confirm/`, {
                                        order_id: this.orderId,
                                        comment: "Заказ сделан через сайт Тюбетей",
                                    })
                                    .then((response) => {
                                        this.onProccess = false;
                                        this.orderObj = response.data;

                                        axios.get("http://127.0.0.1:5000/receipt/print/?text=" + this.orderObj.receipt_text);

                                        setTimeout(function () {
                                            location.href = "/";
                                            localStorage.clear();
                                        }, 12000);
                                    })
                                    .catch((error) => {
                                        console.log("API: ERROR = " + error);
                                    });
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("TERMINAL: ERROR = " + error);
                        this.paymentError = true;
                        this.onProccess = false;
                    });
            });
        }
        if (this.token) {
            //Профиль
            apiClient
                .get(PROJECT_PREFIX + `/profile/`)
                .then((response) => {
                    console.log(response.data);
                    this.can_use_bonuses = response.data.can_use_bonuses;
                })
                .catch((error) => {
                    console.log(error);
                });
            //бонусы
            apiClient
                .get(PROJECT_PREFIX + `/bonuses`)
                .then((response) => {
                    console.log(response.data);
                    this.bonuses = response.data.bonuses;
                    this.percent = response.data.percent;
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    beforeUnmount() {
        let webSocket = new WebSocket(`${process.env.VUE_APP_WS_BASE_URL}/orders/${this.orderId}/`);
        if (webSocket) {
            webSocket.close();
            webSocket = null;
        }
    },
};
</script>

<style lang="scss">
.write-ticoins {
    font-size: 14px;
    line-height: 20px;
    margin-top: 10px;
    .bonuses,
    .write {
        svg {
            margin-left: 2px;
        }
    }
    .bonuses {
        span {
            color: var(--green);
        }
    }
    .write {
        span {
            color: var(--red);
        }
    }
    .write,
    .error {
        margin-top: 5px;
    }
    .error {
        text-align: left;
    }
}
#cart {
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: flex-end;
    @media (max-width: 768px) {
        justify-content: center;
        overflow-x: hidden;
        background: none;
        backdrop-filter: none;
        z-index: 2;
    }
    .btn-back {
        min-width: 32px;
        height: 32px;
        border-radius: 50%;
        overflow: hidden;
        -webkit-box-shadow: 1px 1px 6px rgba(0, 45, 29, 0.05);
        box-shadow: 1px 1px 6px rgba(0, 45, 29, 0.05);
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        order: -1;
        &:hover,
        &:focus {
            background: #eee;
            transition: 0.2s ease 0.2s;
            svg {
                path {
                    stroke: #fff;
                    transition: 0.2s ease 0.2s;
                }
            }
        }
        @media (min-width: 769px) {
            display: none;
        }
    }
    .modal-body {
        overflow-x: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 2px;
        }
        &::-webkit-scrollbar-track {
            background: #99cfab;
            border-radius: 0;
        }
        &::-webkit-scrollbar-thumb {
            background: var(--green);
            border-radius: 0;
            cursor: pointer;
        }
        &::-webkit-scrollbar-thumb:hover {
            opacity: 0.5;
        }
        &__container {
            .btnYandexFood {
                @media (min-width: 768px) {
                    max-width: 100%;
                    min-height: 56px;
                }
            }
        }
    }
    button {
        &[disabled] {
            background: #c8c8c8;
            color: #7a7a7a;
        }
    }
    .tabs {
        @media (max-width: 768px) {
            height: 96px;
            margin-top: 20px;
        }
        .tabs-text {
            span {
                font-size: 12px;
                line-height: 20px;
                color: #000;
            }
        }
    }
    .recom-products {
        margin-right: -20px;
        padding-right: 20px;
        &__product {
            @media (max-width: 768px) {
                height: 104px;
            }
        }
        &__price {
            &.counter {
                background: #fff;
                color: var(--green);
                display: flex;
                justify-content: space-between;
                box-shadow: 0 3px 35px rgb(0, 45, 29, 0.1);
                min-width: 100%;
                min-height: 40px;
                padding: 0;
                .btn-to-cart {
                    min-width: 40px;
                    min-height: 40px;
                    border-radius: 12px;
                    background: #d9f5e4;
                    color: var(--green);
                }
                @media (max-width: 768px) {
                    min-height: 32px;
                    .btn-to-cart {
                        min-width: 32px;
                        min-height: 32px;
                    }
                }
            }
        }
    }
    .btnCart {
        min-width: 100%;
        min-height: 56px;
        border-radius: 30px !important;
        font-size: 16px !important;
        font-family: "Nunito Sans Bold" !important;
        margin-top: 20px;
    }
    .personal-offers__stocks {
        font-size: 14px;
        line-height: 22px;
        color: #1f2120;
        font-family: "Nunito Sans Bold";
    }
    .personal-offers__promocode {
        font-size: 14px;
        line-height: 24px;
        color: #c8c8c8;
        flex: 1 1 auto;
    }
    .personal-offers__block {
        display: flex;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 3px 35px rgb(0, 0, 0, 0.05);
        .btn {
            width: 120px;
            height: 32px;
            margin: 0;
        }
    }
    .personal-offers__body {
        padding: 15px;
        display: flex;
        flex-direction: column;
    }
    .personal-offers__img {
        min-width: 120px;
        max-width: 120px;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    @media (max-width: 768px) {
        justify-content: center;
        overflow-x: hidden;
    }
    .block-flex {
        width: 100%;
        display: flex;
        padding: 10px 15px;
        .block-input {
            flex: 1 1 auto;
            display: flex;
            justify-content: center;
            flex-direction: column;
            position: relative;
            text-align: left;
            .promocode {
                color: var(--green);
            }
            .error {
                color: var(--red);
            }
            .check_promocode {
                font-size: 8px;
                line-height: 12px;
                text-align: center;
                font-family: "Nunito Sans ExtraLight";
                position: absolute;
                top: 0;
                bottom: 0;
                right: 20px;
                display: flex;
                align-items: center;
            }
            .discount {
                font-size: 10px;
                line-height: 16px;
                color: #7a7a7a;
                margin-top: -5px;
                .promocode_active {
                    display: flex;
                    flex-direction: column;
                }
            }
            input {
                font-size: 14px;
                line-height: 24px;
                color: #333;
                flex: 1 1 auto;
                font-family: "Nunito Sans";
                background: none;
                outline: none;
                &::placeholder {
                    color: #c8c8c8;
                }
                &:focus {
                    outline: none;
                }
            }
        }
        .btn {
            min-width: 120px;
            max-width: 120px;
            height: 36px;
            border-radius: 16px;
            font-family: "Nunito Sans Bold";
            font-size: 14px;
            line-height: 22px;
            @media (max-width: 768px) {
                margin-left: -20px;
            }
        }
        .btn-apply {
            background: #d9f5e4;
            color: var(--green);
            &:hover,
            &:focus {
                background: #c5f7d9;
                transition: 0.2s ease 0.2s;
            }
        }
        .btn-remove {
            background: #f4f4f4;
            color: #c8c8c8;
            &:hover,
            &:focus {
                background: #c8c8c8;
                color: #f4f4f4;
                transition: 0.2s ease 0.2s;
            }
        }
    }
    .count-products {
        font-family: "Nunito Sans Bold";
        font-size: 18px;
        line-height: 24px;
        color: #1f2120;
    }
    .products {
        overflow-x: hidden;
        height: 100%;
        &::-webkit-scrollbar {
            width: 5px;
        }
        &::-webkit-scrollbar-track {
            background: #d9f5e4;
            border-radius: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background: var(--green);
            border-radius: 5px;
            cursor: pointer;
        }
        &::-webkit-scrollbar-thumb:hover {
            opacity: 0.5;
        }
        .product {
            width: 100%;
            height: 144px;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 3px 35px rgb(0, 45, 29, 0.05);
            margin-top: 10px;
            display: flex;
            &__img {
                min-width: 144px;
                max-width: 144px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                @media (max-width: 768px) {
                    min-width: 104px;
                }
            }

            &__body {
                display: flex;
                flex-direction: column;
                padding: 10px;
                flex: 1 1 auto;
                @media (max-width: 768px) {
                    padding: 5px 10px;
                }
            }

            &__head {
                flex: 1 1 auto;
            }

            &__title {
                font-size: 14px;
                line-height: 24px;
                color: #1f2120;
                white-space: pre-line;
                @media (max-width: 768px) {
                    font-size: 12px;
                    line-height: 16px;
                    font-family: "Nunito Sans ExtraLight";
                }
            }

            &__weight {
                font-size: 10px;
                line-height: 16px;
                color: #848484;
                &.mod {
                    font-size: 12px;
                }
            }

            &__bottom {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            &__price {
                font-family: "Nunito Sans Bold";
                font-size: 18px;
                line-height: 24px;
                color: #1f2120;
            }
        }
    }
    .counter {
        background: #d9f5e4;
        min-width: 86px;
        max-width: 86px;
        height: 36px;
        border-radius: 16px;
        font-family: "Nunito Sans Bold";
        font-size: 16px;
        line-height: 24px;
        color: var(--green);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        .minus,
        .plus {
            cursor: pointer;
        }
        @media (max-width: 768px) {
            min-width: 64px;
            max-width: 64px;
            height: 24px;
            border-radius: 10px;
            font-size: 12px;
            line-height: 18px;
        }
    }
    .strokes {
        margin-top: auto;
        .stroke {
            width: 100%;
            min-height: 56px;
            background: #fff;
            box-shadow: 0 3px 35px rgb(0, 45, 29, 0.05);
            border-radius: 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;
            font-family: "Nunito Sans Bold";
            font-size: 14px;
            line-height: 22px;
            color: #1f2120;
            cursor: pointer;
            .btn-back {
                position: unset;
                transform: matrix(-1, 0, 0, 1, 0, 0);
            }
            img {
                margin-right: 5px;
            }
            .btn-write {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                padding: 10px 15px;
                min-height: 56px;
                border-radius: inherit;
            }
        }
    }
    .total-price {
        font-size: 14px;
        line-height: 24px;
        color: #1f2120;
        padding-bottom: 35px;
        @media (max-width: 768px) {
            padding-bottom: 20px;
        }
        &__shipping,
        &__total {
            display: flex;
            justify-content: space-between;
        }
        &__total {
            margin-top: 10px;
        }
        .btn {
            width: 100%;
            margin-top: 10px;
        }
    }
    .modal-backdrop {
        width: inherit;
        height: inherit;
        background: rgb(31, 33, 32, 0.5);
        position: absolute;
        @media (max-width: 768px) {
            display: none;
        }
    }
    .modal-block {
        width: fit-content;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: relative;
        right: -100%;
        animation: showModal 0.2s forwards 0.2s;
        @media (max-width: 768px) {
            z-index: 1;
        }
        @keyframes showModal {
            0% {
                opacity: 0;
                right: -100%;
            }
            100% {
                opacity: 1;
                right: 0;
            }
        }
    }
    .modal-btn {
        background: none;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 1px 1px 6px 0 rgba(0, 45, 29, 0.05);
        margin-right: 10px;
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
        &:hover,
        &:focus {
            opacity: 0.5;
            transition: 0.2s ease 0.2s;
        }
    }
    .modal-body {
        background-color: #fff;
        width: 470px;
        height: 100vh;
        border-radius: 16px 0 0 16px;
        box-shadow: 1px 3px 25px 0 rgba(0, 45, 29, 0.1);
        padding: 35px 20px;
        @media (max-width: 768px) {
            width: 100vw;
            height: 100vh;
            border-radius: 0;
            padding: 100px 15px 50px;
        }
        &__container {
            display: flex;
            flex-direction: column;
            height: 100%;
        }

        &__empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1 1 auto;
        }

        &__cart-img {
            width: 242px;
            height: 235px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            @media (max-width: 768px) {
                width: 184px !important;
                height: 179px !important;
                img {
                    object-fit: contain !important;
                }
            }
        }

        &__message {
            font-family: "Nunito Sans Bold";
            font-size: 16px;
            line-height: 24px;
            color: #000;
            text-align: center;
            margin-top: 20px;
            @media (max-width: 768px) {
                font-size: 14px;
                margin-top: 35px;
            }
        }

        &__btn {
            width: 100%;
            min-height: 56px;
            border-radius: 30px;
            font-family: "Nunito Sans Bold";
            font-size: 16px;
            line-height: 24px;
            background: var(--green);
            color: #fff;
            text-align: center;
            margin-top: 20px;
            @media (max-width: 768px) {
                width: fit-content;
                margin: 0 auto;
                padding: 0 30px;
                font-size: 14px;
                min-height: 48px;
            }
        }
        &__cart-img {
            width: 242px;
            height: 235px;
            border-radius: 16px;
            overflow: hidden;
            position: relative;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            @media (max-width: 768px) {
                height: 344px;
                width: 100%;
                .modal-body__prices {
                    position: absolute;
                    bottom: 5px;
                    left: 0;
                    right: 0;
                    width: 97%;
                    height: 40px;
                    margin: 0 auto;
                    padding: 2.5px;
                }
                .modal-body__price {
                    font-size: 12px;
                    line-height: 18px;
                    font-family: "Nunito Sans SemiBold";
                }
            }
        }

        &__bottom {
            padding-top: 10px;
        }

        &__title {
            font-size: 16px;
            line-height: 24px;
            color: #1f2120;
            font-family: "Nunito Sans Bold";
            width: 100%;
            margin-top: 20px;
            @media (max-width: 768px) {
                font-size: 14px;
            }
        }

        &__text {
            font-size: 14px;
            line-height: 24px;
            color: #1f2120;
            margin-top: 20px;
            @media (max-width: 768px) {
                font-size: 12px;
                line-height: 16px;
                font-family: "Nunito Sans ExtraLight";
            }
        }

        &__list {
            margin-top: 10px;
            li {
                font-size: 10px;
                line-height: 16px;
                color: #c8c8c8;
                background: transparent;
                background-image: url("@/assets/img/svg/select.svg");
                background-repeat: no-repeat;
                background-position: 0;
                cursor: pointer;
                padding-left: 1rem;
                margin-top: 5px;
            }
        }

        &__prices {
            background: #f4f4f4;
            border-radius: 12px;
            width: 100%;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 5px;
            margin-top: 20px;
        }

        &__price {
            font-family: "Nunito Sans Bold";
            font-size: 14px;
            line-height: 22px;
            color: #7a7a7a;
            width: 25%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            cursor: pointer;
            &:hover,
            &:focus {
                background: #fff;
                color: #3b7351;
                transition: 0.2s ease 0.2s;
            }
            &.active {
                background: #fff;
                color: #3b7351;
            }
        }

        &__steps {
            display: flex;
            justify-content: space-between;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                margin: auto;
                width: 100%;
                height: 2px;
                background: #c8c8c8;
            }
        }

        &__step {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            line-height: 18px;
            color: #fff;
            background: #c8c8c8;
            position: relative;
            &.active {
                background: #3b7351;
            }
        }
    }
    .block-payment {
        .body {
            margin-top: 20px;
            .block-input {
                input {
                    width: 100%;
                    height: 50px;
                    background: #f4f4f4;
                    border-radius: 12px;
                    margin-top: 5px;
                    padding: 20px;
                }
            }
        }
        .head-title {
            font-size: 16px;
            line-height: 24px;
            color: #1f2120;
            text-align: left;
        }
        .time-shipping {
            margin-top: 5px;
            &__btn {
                width: 50%;
                height: 40px;
                border-radius: 10px;
                box-shadow: 1px 3px 25px rgb(0, 45, 29, 0.05);
                background: #fff;
                font-size: 14px;
                line-height: 22px;
                color: #1f2120;
                font-family: "Nunito Sans Bold";
                &:hover,
                &:focus {
                    border: 1px solid var(--green);
                    color: var(--green);
                    transition: 0.2s ease 0.2s;
                }
            }
        }
        .active {
            border: 1px solid var(--green);
            color: var(--green) !important;
            .methods__title {
                color: var(--green) !important;
            }
        }
        .time-interval {
            display: flex;
            justify-content: space-between;
            margin-top: 15px;
            &__time {
                width: 30%;
                height: 40px;
                border-radius: 10px;
                box-shadow: 0 3px 35px rgb(0, 45, 29, 0.05);
                background: #fff;
                font-size: 14px;
                line-height: 22px;
                color: #1f2120;
                font-family: "Nunito Sans Bold";
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                &:hover,
                &:focus {
                    border: 1px solid var(--green);
                    color: var(--green);
                    transition: 0.2s ease 0.2s;
                }
            }
        }
        .methods {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            &__block {
                width: 49%;
                height: 112px;
                border-radius: 10px;
                box-shadow: 1px 3px 25px rgb(0, 45, 29, 0.05);
                background: #fff;
                cursor: pointer;
                &:hover,
                &:focus {
                    border: 1px solid var(--green);
                    color: var(--green);
                    transition: 0.2s ease 0.2s;
                }
            }

            &__img {
                width: 84px;
                height: 84px;
                margin: 0 auto;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            &__title {
                font-size: 12px;
                line-height: 18px;
                color: #1f2120;
                font-family: "Nunito Sans Bold";
            }
        }
        .total-price {
            margin-top: 10px;
            font-size: 16px;
            line-height: 24px;
            color: #1f2120;
            &__total {
                font-family: "Nunito Sans Bold";
            }
        }
    }
    .status-order {
        margin-top: -1rem;
        .number-order {
            font-size: 18px;
            line-height: 24px;
            color: #1f2120;
            font-family: "Nunito Sans Bold";
            margin-bottom: 20px;
        }
        .status-title {
            font-size: 16px;
            line-height: 24px;
            color: #1f2120;
            font-family: "Nunito Sans Bold";
        }
        .personal-offers {
            &__block {
                height: 144px;
                margin-top: 20px;
            }
            &__body {
                flex: 1 1 auto;
            }
        }
        .products {
            height: 35vh;
        }
        .product {
            &__body {
                padding: 10px 15px 20px;
            }

            &__bottom {
                .count {
                    font-size: 18px;
                    line-height: 24px;
                    color: #1f2120;
                    font-family: "Nunito Sans Bold";
                }
            }
        }
        .address {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 20px;
            border-bottom: 1px solid #f4f4f4;
            padding-bottom: 10px;
            &__title {
                font-size: 16px;
                line-height: 24px;
                color: #1f2120;
                font-family: "Nunito Sans Bold";
            }

            &__street {
                display: flex;
                flex-direction: column;
                span {
                    &:first-child {
                        font-size: 14px;
                        line-height: 24px;
                        color: #1f2120;
                    }
                    &:last-child {
                        font-size: 14px;
                        line-height: 16px;
                        color: #c8c8c8;
                    }
                }
            }
        }
        .time-order {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            border-bottom: 1px solid #f4f4f4;
            padding-bottom: 10px;
            &__order,
            &__done {
                display: flex;
                flex-direction: column;
                span {
                    &:first-child {
                        font-size: 16px;
                        line-height: 24px;
                        color: #1f2120;
                        font-family: "Nunito Sans Bold";
                    }
                    &:last-child {
                        font-size: 14px;
                        line-height: 24px;
                        color: #1f2120;
                    }
                }
            }
        }
        .total-price {
            margin-top: 10px;
            &__t-coins {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                span {
                    &:last-child {
                        color: var(--green);
                    }
                }
                &.write {
                    span {
                        &:last-child {
                            color: var(--red);
                        }
                    }
                }
            }
            &__discounts {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                color: #333;
            }
        }
    }
}
#comment-order {
    width: 100%;
    height: 113px;
    background: #f4f4f4;
    border-radius: 12px;
    margin-top: 5px;
    padding: 10px;
    resize: none;
    &::placeholder {
        font-size: 14px;
        line-height: 24px;
        color: #c8c8c8;
        font-family: "Nunito Sans";
    }
}

.error {
    display: block;
    font-size: 16px;
    font-weight: 600;
    color: var(--red);
    text-align: center;
    white-space: pre-line;
}
</style>
